import { useEffect } from 'react'
import { TEXTOS } from './glossario'
import { itemAtivo } from './navegacao'

/** O que a aba do navegador diz quando nenhuma tela do menu está aberta. */
const NOME_DO_SISTEMA = TEXTOS.nomeDoSistema

/**
 * Mantém o título da aba do navegador coerente com a tela aberta.
 *
 * **O título era fixo.** `index.html` trazia `<title>… — GMUD</title>` e nada nunca o
 * mudava: quem estivesse em Chamados, em Ordens de Serviço, em Indicadores ou na Administração via
 * "GMUD" escrito na aba. Com duas ou três abas abertas — que é como se confere um fechamento, o
 * documento de um lado e a tela do outro — as abas ficavam indistinguíveis, e o histórico do
 * navegador guardava "GMUD" para toda página já visitada.
 *
 * **O rótulo sai do menu, não de uma segunda lista.** `itemAtivo` já resolve o endereço para o item
 * de navegação, e é dele que vem o nome. Uma tabela de títulos aqui seria a mesma string escrita em
 * dois lugares — o defeito que a Regra nº 4 existe para impedir —, e ela ficaria velha na primeira
 * vez que alguém renomeasse um item do menu.
 *
 * @param caminho o `pathname` atual
 * @param busca a query string atual, que é o que separa a lista do histórico
 */
export function useTituloDaPagina(caminho: string, busca: string) {
  useEffect(() => {
    const item = itemAtivo(caminho, busca)
    document.title = item ? `${item.rotulo} — ${NOME_DO_SISTEMA}` : NOME_DO_SISTEMA
  }, [caminho, busca])
}
